export class SecurityPolicy {
    public passwordMinCasesLength: number;
    public passwordMaxCasesLength: number;
    public passwordMinUpperCasesLength: number;
    public passwordMinLowerCasesLength: number;
    public passwordMinDigitsLength: number;
    public passwordMinSpecialCasesLength: number;
    public passwordSpecialCases: string;
    public passwordMaxDays: number;
    public passwordHistoryCount: number;
    public passwordMaxAttempts: number;
    public sessionTimeout: number;
}
